// src/admin/meditation/Meditation.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import { makeSelectMeditationConfigById, useDeleteMeditationConfigMutation } from '../../features/meditation/meditationApi';
import { memo } from 'react';
import { useSelector } from 'react-redux';

const Meditation = ({ configId, index }) => {
  // ✅ Curried selector with cache key
  const config = useSelector(makeSelectMeditationConfigById(configId, 'meditationList'));

  console.log(`Meditation ID: ${configId}, Selected Config:`, config);

  const [deleteConfig, {
    isSuccess: isDelSuccess,
    isError: isDelError,
    error: delError
  }] = useDeleteMeditationConfigMutation();

  const navigate = useNavigate();

  const handleEdit = () => {
    navigate(`/dashboard/meditation/${configId}`);
  };

  const onDeleteConfigClicked = async () => {
    if (window.confirm("क्या आप वाकई इस ध्यान कॉन्फ़िग को डिलीट करना चाहते हैं?")) {
      await deleteConfig(configId);
    }
  };

  if (!config) {
    console.log(`Meditation ID: ${configId}, Config is null. Not rendering.`);
    return null;
  }

  return (
    <>
      <tr className="table__row">
        <td className="table__cell">{index + 1}</td>
        <td className="table__cell">{config.name}</td>
        <td className="table__cell">{config.category}</td>
        <td className="table__cell">{config.dayOfWeek}</td>
        <td className="table__cell">{config.startTime} - {config.endTime}</td>
        <td className="table__cell">{config.type}</td>
        <td className="table__cell">{config.isActive ? 'Yes' : 'No'}</td>
        <td className="table__cell">
          <button
            className="icon-button table__button"
            onClick={handleEdit}
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            className="icon-button table__button"
            onClick={onDeleteConfigClicked}
          >
            <FontAwesomeIcon icon={faTrashCan} />
          </button>
        </td>
      </tr>
      {isDelError && (
        <tr>
          <td colSpan={7} style={{ color: 'red', textAlign: 'center' }}>
            {delError?.data?.message || "Delete Error"}
          </td>
        </tr>
      )}
    </>
  );
};

export default memo(Meditation);
